const navi = [{
    path: 'welcome',
    title: '开始'
  },
  {
    path: 'meta',
    title: '基础信息',
    children: [{
        path: 'enterprise',
        title: '主体管理'
      },
      {
        path: 'park',
        title: '园区管理'
      },
      {
        path: 'land',
        title: '地块管理'
      },
      {
        path: 'person',
        title: '人员管理'
      },
    ]
  },
  {
    path: 'plant',
    title: '种植管理',
    children: [{
        path: 'variety',
        title: '品种管理'
      },
      {
        path: 'scheme',
        title: '种植方案'
      }
    ]
  },
  {
    path: 'resource',
    title: '生产资料',
    children: [{
        path: 'equip',
        title: '设备管理'
      },
      {
        path: 'inputs',
        title: '投入品管理'
      }
    ]
  },
  {
    path: 'product',
    title: '生产过程',
    children: [{
        path: 'plan/list',
        title: '种植'
      },
      {
        path: 'plan/labor',
        title: '用工'
      },
      {
        path: 'plan/inputs',
        title: '投入'
      },
      {
        path: 'plan/harvest',
        title: '采摘'
      },
    ]
  },
  {
    path: 'monitor',
    title: '监测预警',
    children: [{
        path: 'evironment',
        title: '环境监控'
      },
      // {
      //   path: 'fertilizer',
      //   title: '水肥监测'
      // },
      // {
      //   path: 'sapling',
      //   title: '苗情监测'
      // },
      // {
      //   path: 'soil',
      //   title: '土壤检测'
      // },
      // {
      //   path: 'disease',
      //   title: '病虫害监测'
      // }
    ]
  },
  // {
  //   path: 'quality',
  //   title: '质量安全',
  //   children: [{
  //       path: 'detect',
  //       title: '质量检测'
  //     },
  //     {
  //       path: 'trace',
  //       title: '溯源管理'
  //     }
  //   ]
  // },
  // {
  //   path: 'report',
  //   title: '生产报表',
  //   children: [{
  //       path: 'environment',
  //       title: '环境报表'
  //     },
  //     {
  //       path: 'inputs',
  //       title: '投入报表'
  //     },
  //     {
  //       path: 'labor',
  //       title: '用工报表'
  //     },
  //     {
  //       path: 'harvest',
  //       title: '采收报表'
  //     }
  //   ]
  // },
  // {
  //   path: 'dashboard',
  //   title: '可视化平台',
  //   children: [{
  //       path: 'component',
  //       title: '组件管理'
  //     },
  //     {
  //       path: 'panel',
  //       title: '面板管理'
  //     }
  //   ]
  // },
  // {
  //   path: 'logs',
  //   title: '操作日志',
  //   children: [{
  //       path: 'intellect',
  //       title: '调控日志'
  //     },
  //     {
  //       path: 'manual',
  //       title: '操作日志'
  //     }
  //   ]
  // },
  {
    path: 'profile',
    title: '系统设置',
    children: [{
      path: '',
      title: '账户管理'
    }]
  }
]

function Navigator() {
  var data = navi
  var breads = ['主页']
  var clippedPath = undefined

  this.getNaviData = function () {
    return data
  }

  this.setCurrentPath = function (p) {
    clippedPath = ''
    breads.length = 1
    let menus = data
    const paths = p.split('/')
    for (let i = 1; i < paths.length; i++) {
      const path = paths[i]
      clippedPath += `/${path}`
      const menu = menus.find(item => {
        return item.path === path
      })
      if (menu) {
        breads.push(menu.title)
      }
      if (!menu.children || menu.children.length === 0) {
        break
      }
      menus = menu.children
    }
    // 生成导航路径
  }

  /**
   * 读取对导航菜单有效的路径（裁剪那些比导航菜单更深的路径）
   */
  this.getClippedPath = function () {
    return clippedPath
  }

  this.getBreadcrumb = function () {
    return breads
  }
}
// export default navi
export default new Navigator()



// WEBPACK FOOTER //
// ./src/components/navi.js